module.exports = __webpack_public_path__ + "static/media/5.3b599a70.gif";